export const ASN_CODE = 1;
export const JENIS_PENGGUNA = [
  {
    label: 'ASN',
    value: 1,
  },
  {
    label: 'NON ASN',
    value: 2,
  },
];
